export const EVENT_BOOKING_FLOW = 'event_booking_approval_first_v1';
export const isApprovalFirstEvent = (booking) => booking?.eventBookingFlowVersion === EVENT_BOOKING_FLOW;

export function eventBookingProgress(booking, nowMs = Date.now()) {
  if (!isApprovalFirstEvent(booking)) return null;
  const status = String(booking.status || booking.confirmationStatus || '').toLowerCase();
  if (booking.paymentReviewRequired) return { label: 'Pago en revisión', message: 'El negocio debe revisar el pago antes de confirmar el evento.', canPay: false };
  if (['cancelled', 'canceled', 'rejected', 'declined', 'deleted', 'completed', 'no_show'].includes(status)) return null;
  const deadline = Number(booking.paymentHoldExpiresAtMs);
  if (['expired', 'payment_expired'].includes(status) || (status === 'pending_payment' && deadline > 0 && deadline <= nowMs)) {
    return { label: 'Plazo de pago vencido', message: 'Consulta con el negocio para comprobar nuevamente la disponibilidad.', canPay: false };
  }
  if (booking.eventApprovalStatus !== 'approved') return {
    label: 'Esperando aprobación', message: 'El negocio revisará la disponibilidad. Todavía no tienes que pagar.', canPay: false,
  };
  if (status === 'pending_payment') return {
    label: 'Aprobada · falta el abono', message: 'Tu evento se confirma cuando se registra el abono requerido.', canPay: true,
    amountCents: Number.isSafeInteger(booking.requiredBookingPaymentAmountInCents) ? booking.requiredBookingPaymentAmountInCents : null,
    deadlineMs: deadline > 0 ? deadline : null,
  };
  return null;
}
